export default __webpack_public_path__ + "static/media/bar_icon_black.b2e8ceba.svg";